<div class="settings-page">
  <div class="container py-3">
    <div class="page-header d-flex flex-wrap align-items-center justify-content-between gap-3 mb-4">
      <div>
        <h2 class="page-title mb-1">Settings</h2>
        <p class="page-subtitle mb-0">
          Choose who appears on <a routerLink="/employees">Employees</a>.
          Hidden people stay in the system and are left out of that list.
        </p>
      </div>
      <button type="button" class="btn btn-primary btn-add" (click)="load()">Refresh</button>
    </div>

    @if (loadError) {
      <div class="alert alert-danger d-flex flex-wrap justify-content-between align-items-center gap-2">
        <span>Could not load people.</span>
        <button type="button" class="btn btn-sm btn-outline-danger" (click)="load()">Try again</button>
      </div>
    }

    <div class="row g-3 mb-4">
      <div class="col-4">
        <button type="button" class="stat-card" [class.active]="view === 'all'" (click)="showView('all')">
          <span class="stat-label">Everyone</span>
          <span class="stat-value">{{ counts.all }}</span>
        </button>
      </div>
      <div class="col-4">
        <button type="button" class="stat-card" [class.active]="view === 'shown'" (click)="showView('shown')">
          <span class="stat-label">Shown</span>
          <span class="stat-value">{{ counts.shown }}</span>
        </button>
      </div>
      <div class="col-4">
        <button type="button" class="stat-card" [class.active]="view === 'hidden'" (click)="showView('hidden')">
          <span class="stat-label">Hidden</span>
          <span class="stat-value">{{ counts.hidden }}</span>
        </button>
      </div>
    </div>

    <div class="card filter-card mb-4">
      <div class="card-body py-3">
        <label class="form-label small text-muted mb-1" for="settings-search">Search</label>
        <input
          id="settings-search"
          type="search"
          class="form-control"
          placeholder="Name, username, phone, or role..."
          [(ngModel)]="searchTerm"
          (ngModelChange)="onFilterChange()"
        />
      </div>
    </div>

    <div class="card table-card">
      <div class="card-header d-flex justify-content-between align-items-center">
        <span>Employee visibility</span>
        @if (filteredPeople.length > 0) {
          <span class="badge rounded-pill bg-light text-dark">{{ filteredPeople.length }} person(s)</span>
        }
      </div>
      <div class="card-body p-0">
        <div class="table-responsive">
          <table class="table table-hover settings-table mb-0">
            <thead>
              <tr>
                <th scope="col" class="col-num">#</th>
                <th scope="col">Person</th>
                <th scope="col">Role</th>
                <th scope="col">Status</th>
                <th scope="col">On Employees</th>
              </tr>
            </thead>
            <tbody>
              @if (filteredPeople.length === 0) {
                <tr>
                  <td colspan="5" class="empty-state">
                    <div class="empty-content">
                      <p class="mb-1 fw-semibold">No people found</p>
                      <p class="text-muted small mb-0">Try another search, or switch the view above.</p>
                    </div>
                  </td>
                </tr>
              }
              @for (person of paginatedPeople; track person.id; let i = $index) {
                <tr [class.row-hidden]="person.hidden">
                  <td class="text-muted">{{ (page - 1) * pageSize + i + 1 }}</td>
                  <td>
                    <div class="fw-semibold">{{ person.name }}</div>
                    <div class="subline">
                      {{ person.username || 'No username' }}
                      @if (person.phone) {
                        <span> · {{ person.phone }}</span>
                      }
                    </div>
                  </td>
                  <td>{{ person.role ? (person.role | titlecase) : '—' }}</td>
                  <td>{{ statusLabel(person.status) }}</td>
                  <td>
                    <div class="d-flex align-items-center gap-2">
                      <div class="form-check form-switch mb-0">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          role="switch"
                          [checked]="!person.hidden"
                          [disabled]="savingId === person.id"
                          [attr.aria-label]="'Show ' + person.name + ' on Employees'"
                          (change)="toggle(person, $event)"
                        />
                      </div>
                      <span class="small" [class.text-muted]="!person.hidden" [class.hidden-label]="person.hidden">
                        {{ person.hidden ? 'Hidden' : 'Shown' }}
                      </span>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      @if (filteredPeople.length > pageSize) {
        <div class="card-footer bg-white border-top-0 pagination-footer">
          <ngb-pagination
            class="mb-0"
            [collectionSize]="filteredPeople.length"
            [(page)]="page"
            [pageSize]="pageSize"
            [maxSize]="5"
            [rotate]="true"
            [boundaryLinks]="true"
          ></ngb-pagination>
        </div>
      }
    </div>
  </div>
</div>
